var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationUnlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3164,
    cy: 10,
    r: 9.75,
    fill: "#EAFFF8",
    stroke: "#29C18C",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_3106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9621 8.88414C13.6316 8.73252 13.0664 8.68919 13.0664 8.68919H8.63039C8.63039 8.25598 8.61972 7.81194 8.63039 7.37873C8.65171 6.47981 9.05693 5.7975 9.8247 5.37512C10.5925 4.96356 11.3709 4.99605 12.1067 5.47259C12.7892 5.91663 13.1197 6.56645 13.1517 7.37873C13.1624 7.7253 13.4076 7.96356 13.7275 7.9419C14.0368 7.92024 14.2501 7.66031 14.2287 7.31374C14.2181 7.20544 14.2181 7.09714 14.2074 6.98883C13.9941 5.09353 12.2133 3.72891 10.3685 4.04299C8.72636 4.31374 7.54271 5.72169 7.54271 7.40039C7.54271 7.90941 7.54271 8.40761 7.54271 8.91663C7.54271 8.93829 7.54271 8.93829 7.54271 8.95995C6.79626 9.34984 6.31641 10.1188 6.31641 10.9744V13.7145C6.31641 14.9708 7.32944 15.9997 8.56641 15.9997H13.0664C14.3034 15.9997 15.3164 14.9708 15.3164 13.7145V10.9744C15.3164 10.0646 14.7832 9.24154 13.9621 8.88414Z",
    fill: "#29C18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1365 14.3971V14.917H10.3048V14.4188C9.76094 14.343 9.32373 14.1697 8.99316 13.8773L9.537 13.1083C9.87824 13.3791 10.2621 13.4982 10.6887 13.4982C11.0832 13.4982 11.3285 13.3682 11.3285 13.1408C11.3285 12.9134 11.1259 12.8159 10.646 12.7726C9.57966 12.6751 9.11046 12.3069 9.11046 11.5812C9.11046 10.9639 9.537 10.509 10.2301 10.3574V9.80505H11.0512V10.3249C11.5098 10.3682 11.8936 10.509 12.2242 10.7365L11.7443 11.4838C11.4564 11.2888 11.1472 11.1913 10.806 11.1913C10.3901 11.1913 10.1342 11.3213 10.1342 11.5271C10.1342 11.7437 10.3154 11.8412 10.806 11.8845C11.819 11.9928 12.3628 12.426 12.3628 13.1516C12.3522 13.8014 11.883 14.278 11.1365 14.3971Z",
    fill: "#EAFFF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_3106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 12,
    fill: "white",
    transform: "translate(6.31641 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUnlock);
export default __webpack_public_path__ + "static/media/notification_unlock.0650ba6d43fc66f344ca081d8916d9b9.svg";
export { ForwardRef as ReactComponent };